import i18n from "../../i18next/i18next";

export const clientTypes = () => {
  const { t } = i18n;
  return [
    {
      name: t("global:analyst.clientTypeIndividual"),
      value: "INDIVIDUAL",
    },
    {
      name: t("global:analyst.clientTypeInstitutional"),
      value: "INSTITUTIONAL",
    },
  ];
};
